import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IBankAccount } from "../bankaccountModel";

export const getAllActiveBankAccounts = createAsyncThunk(
  "BankAccount/FindAllActiveBankAccount",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/BankAccount/FindAllActiveBankAccount`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Bank Accounts:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllBankAccounts = createAsyncThunk(
  "BankAccount/FindAllBankAccount",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BankAccount/FindAllBankAccount`,
        {
          BankName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Bank Accounts:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createBankAccount = createAsyncThunk(
  "BankAccount/InsertBankAccount",
  async (FormData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BankAccount/InsertBankAccount`,
        FormData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Bank Account:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateBankAccount = createAsyncThunk(
  "BankAccount/UpdateBankAccount",
  async (FormData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BankAccount/UpdateBankAccount`,
        FormData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Bank Account:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteBankAccount = createAsyncThunk(
  "BankAccount/DeleteBankAccount",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BankAccount/DeleteBankAccount`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Bank Account:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getBankAccountByID = createAsyncThunk(
  "BankAccount/FindByIDBankAccount",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BankAccount/FindByIDBankAccount`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        BankName: result.BankName,
        AccountNo: result.AccountNo,
        IFSCCode: result.IFSCCode,
        BranchName: result.BranchName,
        Address: result.Address,
        IsActive: result?.IsActive ? 1 : 2,
      } as IBankAccount;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Bank Account:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveBankAccount = createAsyncThunk(
  "BankAccount/ActiveInActiveBankAccount",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BankAccount/ActiveInActiveBankAccount`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive BankAccount:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
